"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PrintShareMenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Print = _interopRequireDefault(require("@kyruus/react-ikons/Print"));
var _style = require("./style");
const createClickHandler = onBeforeClickHandler => {
  return e => {
    if (onBeforeClickHandler) {
      onBeforeClickHandler(e);
    }
    if (!e.isDefaultPrevented()) {
      print();
    }
  };
};
const PrintButton = _ref => {
  let {
    showLabel,
    label = 'Print',
    onBeforeClick,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_style.StyledIconButton, (0, _extends2.default)({}, props, {
    onClick: createClickHandler(onBeforeClick)
  }), /*#__PURE__*/_react.default.createElement(_Print.default, {
    size: _style.ICON_HEIGHT,
    "aria-hidden": true,
    title: "",
    "data-testid": "print-svg"
  }), showLabel ? /*#__PURE__*/_react.default.createElement(_style.StyledLabel, null, label) : null);
};
const PrintShareMenuItem = _ref2 => {
  let {
    showLabel,
    label,
    onClick,
    ...props
  } = _ref2;
  const handleClick = () => {
    if (onClick) {
      onClick('print');
    }
    // check for window in case this is ever server-side-rendered
    if (typeof window !== 'undefined') {
      print();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_style.StyledMenuItem, (0, _extends2.default)({}, props, {
    onClick: () => {
      handleClick();
    }
  }), /*#__PURE__*/_react.default.createElement(_Print.default, {
    size: _style.ICON_HEIGHT,
    "aria-hidden": "true",
    title: "",
    "data-testid": "print-svg"
  }), showLabel ? /*#__PURE__*/_react.default.createElement(_style.StyledLabel, null, label) : null);
};
exports.PrintShareMenuItem = PrintShareMenuItem;
PrintButton.propTypes = {
  /**
   * Whether to show the 'email' label or not
   */
  showLabel: _propTypes.default.bool,
  /**
   * Label content
   */
  label: _propTypes.default.node,
  /**
   * Called before the the onClick is executed for the link.
   */
  onBeforeClick: _propTypes.default.func
};
PrintShareMenuItem.propTypes = {
  /**
   * Whether to show the 'Print' label or not
   */
  showLabel: _propTypes.default.bool,
  /**
   * Label content
   */
  label: _propTypes.default.node,
  /**
   * Called before the the onClick is executed for the link.
   */
  onClick: _propTypes.default.func
};
var _default = exports.default = PrintButton;
PrintShareMenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PrintShareMenuItem",
  "props": {
    "showLabel": {
      "description": "Whether to show the 'Print' label or not",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "Label content",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onClick": {
      "description": "Called before the the onClick is executed for the link.",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};
PrintButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PrintButton",
  "props": {
    "label": {
      "defaultValue": {
        "value": "'Print'",
        "computed": false
      },
      "description": "Label content",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "showLabel": {
      "description": "Whether to show the 'email' label or not",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onBeforeClick": {
      "description": "Called before the the onClick is executed for the link.",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};